import { Button } from '@/components/ui/button';
import { NavDropdown } from '@/shared/components/nav-dropdown';
import { router } from '@/shared/router';
import { useUiStore } from '@/shared/store/ui-store';
import { getConfig } from '@/utils/config';
import { Link } from '@tanstack/react-router';
import { KeyIcon, MessageSquareTextIcon, XIcon } from 'lucide-react';

function MenuSidebarItem({
  icon,
  label,
  to,
  tag,
  hoverText,
  external,
}: {
  icon: React.ReactNode;
  label: string;
  to: string;
  tag?: string;
  hoverText?: string;
  external?: boolean;
}) {
  const content = (
    <div
      className="text-muted hover:bg-active flex items-center gap-2 truncate rounded-md px-2 py-2 text-base"
      title={hoverText}
    >
      {icon}
      <span>{label}</span>
      {tag && (
        <span className="bg-primary text-primary-foreground ml-2 rounded px-1.5 text-[10px] font-semibold">
          {tag}
        </span>
      )}
    </div>
  );
  if (external) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noreferrer"
        className="block"
      >
        {content}
      </a>
    );
  }
  return (
    <Link
      to={to}
      className="block"
    >
      {content}
    </Link>
  );
}

export function MenuSidebar() {
  const { isMenuSidebarOpen, setIsMenuSidebarOpen } = useUiStore();
  const {
    chat: { baseUrl },
  } = getConfig();

  router.subscribe('onResolved', () => {
    setIsMenuSidebarOpen(false);
  });

  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-black/40 transition-opacity duration-300 ${isMenuSidebarOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'}`}
        onClick={() => setIsMenuSidebarOpen(false)}
        aria-hidden="true"
      />

      <aside
        className={`bg-card fixed top-0 right-0 z-50 h-full w-80 max-w-full shadow-lg transition-transform duration-300 sm:w-96 ${isMenuSidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="border-border flex items-center justify-between border-b p-4">
          <span className="text-lg font-semibold">EmbraceableAI</span>
          <Button
            onClick={() => setIsMenuSidebarOpen(false)}
            aria-label="Close menu sidebar"
            variant="ghost"
          >
            <XIcon className="size-5" />
          </Button>
        </div>
        <div className="flex h-[calc(100%-65px)] flex-col overflow-y-auto">
          <div className="flex-1 p-4">
            <div className="flex flex-col gap-2">
              <MenuSidebarItem
                icon={<KeyIcon className="size-5" />}
                label={'API-Schlüssel'}
                to={'/api-key'}
              />
              <MenuSidebarItem
                icon={<MessageSquareTextIcon className="size-5" />}
                label={'e2 Chat'}
                to={baseUrl}
                external
              />
            </div>
          </div>
          <div className="border-t p-4">
            <NavDropdown />
          </div>
        </div>
      </aside>
    </>
  );
}
